module.exports = __webpack_public_path__ + "static/dc51-969fd2ee2f8119290f33dc75ef942a6d.jpg";